import { PageKey } from '@core/enums/page-keys.enum';
import { FlowId, type CheckinWorkflow } from '../workflow-engine.types';

export enum GreetingsWelcomeStep {
  Page = 'Page',
}

export const greetingsWelcomeFlow: CheckinWorkflow<GreetingsWelcomeStep> = {
  id: FlowId.GreetingsWelcome,
  entry: GreetingsWelcomeStep.Page,
  steps: {
    [GreetingsWelcomeStep.Page]: {
      id: GreetingsWelcomeStep.Page,
      page: PageKey.GREETINGS_WELCOME,
      next: () => ({ complete: true }),
    },
  },
};
